function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13,
  fill: "url(#online_svg__online0_linear)",
  fillOpacity: 0.9
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillOpacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.728 24.556l2.828-2.828L29.8 25.97a2 2 0 01-2.828 2.828l-4.243-4.243z",
  fill: "url(#online_svg__online1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.657 14.657a2 2 0 011.697-.566l9.9 1.414a2 2 0 011.13 3.394L19.9 27.386a2 2 0 01-3.394-1.132l-1.414-9.9a2 2 0 01.566-1.696z",
  fill: "url(#online_svg__online2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "online_svg__online0_linear",
  x1: 2.773,
  y1: 1,
  x2: 23.454,
  y2: 22.864,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59E5EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81BDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "online_svg__online1_linear",
  x1: 15,
  y1: 14,
  x2: 30,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABD0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "online_svg__online2_linear",
  x1: 15,
  y1: 14,
  x2: 30,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABD0FF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "online_svg__filter0_b",
  x: 9.071,
  y: 8.071,
  width: 27.314,
  height: 27.314,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,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";
export { SvgOnline as ReactComponent };